import type { FC } from "react";

interface ConcentricCirclesProps {
  color?: string;
  animated?: boolean;
}

const ConcentricCircles: FC<ConcentricCirclesProps> = ({
  color = "#4CAF50",
  animated = true,
}) => {
  return (
    <div className="relative flex h-8 w-8 items-center justify-center">
      {/* outer circle */}
      <div
        className={`absolute h-8 w-8 rounded-full border-2 ${
          animated ? "animate-ping" : ""
        }`}
        style={{
          borderColor: color,
          opacity: 0.6,
          animationDuration: "2s",
        }}
      />

      {/* middle circle */}
      <div
        className={`absolute h-6 w-6 rounded-full border-2 ${
          animated ? "animate-ping" : ""
        }`}
        style={{
          borderColor: color,
          opacity: 0.4,
          animationDuration: "2s",
          animationDelay: "0.5s",
        }}
      />

      {/* inner circle */}
      <div
        className="h-4 w-4 rounded-full"
        style={{
          backgroundColor: color,
        }}
      />
    </div>
  );
};

export default ConcentricCircles;
